const smsDogrulamaKodu = (value, message) => {
  if (!value) {
    return null;
  }

  if (value.length !== 6) {
    return message ?? "Lütfen geçerli bir değer gir!";
  }

  return null;
};

export default smsDogrulamaKodu;
